// src/navBar/NavBar.jsx
import React, { useState } from 'react';
import './NavBar.css';
import diagonalImage from '../Assets/diagonal.jpg';
import { useMenuToggle, useScreenSize } from './NavBarLogic';
import { Link } from 'react-router-dom';

const NavBar = () => {
  const { menuOpen, toggleMenu, handleMouseEnter, handleMouseLeave } = useMenuToggle(2000);
  const isSmallScreen = useScreenSize(768);

  const logoText = isSmallScreen
    ? 'Web & App<br>Lars Gregersen'
    : 'Web & App<br>Lars Schou Gregersen';

  const [menu, setMenu] = useState("forside");

  return (
    <div className={`navbar menu ${menuOpen ? 'active' : ''}`}>
      <div className="nav-logo">
        <Link to="/"><h1 dangerouslySetInnerHTML={{ __html: logoText }}></h1> </Link>
      </div>

      <div className="nav-image">
        <img src={diagonalImage} alt="Dekorativt billede" />
      </div>

      <nav className="nav-menu">
        {/* Inline menu */}
        <ul className="menu-links inline">
          <li onClick={() => setMenu("forside")}><Link to='/'>Forside</Link></li>
          <li onClick={() => setMenu("Portefølje")}><Link to='/Portefølje'>Portefølje</Link></li>
          <li onClick={() => setMenu("om mig")}><Link to='/om'>Om mig</Link></li>
          <li onClick={() => setMenu("Tjenester")}><Link to='/Tjenester'>Tjenester</Link></li>
          <li onClick={() => setMenu("kontakt")}><Link to='/kontakt'>Kontakt</Link></li>
        </ul>

        {/* Dropdown menu */}
        <ul
          className="menu-links dropdown"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <li onClick={() => setMenu("forside")}><Link to='/'>Forside</Link></li>
          <li onClick={() => setMenu("Portefølje")}><Link to='/Portefølje'>Portefølje</Link></li>
          <li onClick={() => setMenu("om mig")}><Link to='/om'>Om mig</Link></li>
          <li onClick={() => setMenu("Tjenester")}><Link to='/Tjenester'>Tjenester</Link></li>
          <li onClick={() => setMenu("kontakt")}><Link to='/kontakt'>Kontakt</Link></li>
        </ul>

        <button className="menu-toggle" aria-label="Toggle menu" onClick={toggleMenu}>
          ☰
        </button>
      </nav>
    </div>
  );
};

export default NavBar;
